module.exports = __webpack_public_path__ + "media/chicken-road-win.df441e94.mp3";